import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../util/axiosBaseQuery";
import { AssetGroup, SUPAssetGroup } from "../../types/assetGroup";


const processAssetGroupData = (assetGroupData: any): AssetGroup => {
    return {
        id: assetGroupData.id,
        name: assetGroupData.name,
        langNames: assetGroupData.langNames,
        description: assetGroupData.description,
        limit: assetGroupData.limit,
        availabilities: assetGroupData.availibility,
        isFullDay: assetGroupData.isFullDay,
    };
};

const processSUPAssetGroupData = (assetGroupData: any): SUPAssetGroup => {
    return {
        id: assetGroupData.id,
        name: assetGroupData.name,
        langNames: assetGroupData.langNames,
        description: assetGroupData.description,
        availabilities: assetGroupData.availibility,
        isFullDay: assetGroupData.isFullDay,
    };
}

export const availabilitiesApiSlice = createApi({
    reducerPath: "availabilitiesApiSlice",
    baseQuery: axiosBaseQuery(),
    tagTypes: ["availabilities"],
    endpoints: (builder) => ({
            fetchAssetGroupAvailabilities: builder.query<AssetGroup, { assetGroupId: string, from: Date, to: Date, customerAgreementId?: string }>({
                query: ({ assetGroupId, from, to, customerAgreementId }) => {
                    const fromDate = from.toISOString();
                    const toDate = to.toISOString();
                    let url = `/group/${assetGroupId}/availabilities/${fromDate}/${toDate}`;
                    if (customerAgreementId) {
                        url += `?customerAgreementId=${encodeURIComponent(customerAgreementId)}`;
                    }
                    return url;
                },
            transformResponse: (response: any) => {
                // Process the response data before returning it
                return processAssetGroupData(response);
            },
            providesTags: ['availabilities'],
          }),
    }),
});

export const supAvailabilitiesApiSlice = createApi({
    reducerPath: "supAvailabilitiesApiSlice",
    baseQuery: axiosBaseQuery(),
    tagTypes: ["supAvailabilities"],
    endpoints: (builder) => ({
        fetchAssetGroupSUPAvailabilities: builder.query<SUPAssetGroup, { assetGroupId: string, from: Date, to: Date }>({
            query: ({ assetGroupId, from, to }) => {
              const fromDate = from.toISOString();
              const toDate = to.toISOString();
              return `/group/sup/${assetGroupId}/availabilities/${fromDate}/${toDate}`;
            },
            transformResponse: (response: any) => {
                // Process the response data before returning it
                return processSUPAssetGroupData(response);
            },
            providesTags: ['supAvailabilities'],
          }),
    }),
});

export const {useFetchAssetGroupAvailabilitiesQuery} = availabilitiesApiSlice;
